import {
    FETCH_PARTNER_SUBSCRIPTIONS_REQUEST,
    FETCH_PARTNER_SUBSCRIPTIONS_SUCCESS,
    FETCH_PARTNER_SUBSCRIPTIONS_FAILURE,
} from "../actions/types";

const initialState = {
    subscriptions: [],
    loading: false,
    error: null,
    message: "",
};

const partnerSubscriptionReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case FETCH_PARTNER_SUBSCRIPTIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_PARTNER_SUBSCRIPTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                subscriptions: action.payload || [],
                message:
                    "Partner subscriptions loaded successfully",
            };

        case FETCH_PARTNER_SUBSCRIPTIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default partnerSubscriptionReducer;